import { createAction } from '@reduxjs/toolkit';

export interface MarkCrossFeatureCacheStalePayload {
  domain: 'expenseInvoices';
  scope: 'list';
  source: 'bookingSimplifiedCostQuickCreate';
  bookingId: number;
}

export const markCrossFeatureCacheStale = createAction<MarkCrossFeatureCacheStalePayload>(
  'crossFeature/cacheStaleMarked'
);

